import { render, staticRenderFns } from "./EditorActionBar.vue?vue&type=template&id=49488f78&scoped=true&"
import script from "./EditorActionBar.vue?vue&type=script&lang=js&"
export * from "./EditorActionBar.vue?vue&type=script&lang=js&"
import style0 from "./EditorActionBar.vue?vue&type=style&index=0&id=49488f78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49488f78",
  null
  
)

export default component.exports